export default __webpack_public_path__ + "static/media/banner1Dashboard.f2957af1.webp";